module.exports = __webpack_public_path__ + "media/app/img/forward-9157229234c289dfbcf90c17bfb301ce.png";